<template>
  <component :is="tag" v-bind="$attrs" v-on="hooks">

    <a class="panel-block dynamic-list"
      v-for="(row, rowIndex) in value"
      :key="rowIndex">

      <div :class="layoutClass">
        <!-- components: could be selector, text box, date picker, or file upload -->
        <component
          v-for="(item, i) in rowTemplate"
          :key="i"
          :class="isColumn ? 'is-fullwidth' : ''"
          :value="row[item.label]"
          @input="changeValue(rowIndex, item.label, $event, item.component)"
          :is="item.component"
          v-bind="item.bind"
          :disabled="disabled">
        </component>
      </div>

      <!-- visibility toggle -->
      <v-checkbox
        v-if="hasVisibilityToggle && !disabled"
        v-model="row.visible"/>

      <!-- delete row -->
      <a
        v-if="hasDeleteButton && !disabled"
        class="delete"
        @click="value.splice(rowIndex, 1)">
      </a>

    </a>

    <button
      v-if="hasAddButton && !disabled"
      @click="value.push({...placeholder})"
      class="button is-small is-primary is-rounded add-button">
      + add
    </button>

  </component>
</template>

<script>
import VSelect from '@/components/base/VSelect'
import VTextField from '@/components/base/VTextField'
import VFileUpload from '@/components/base/VFileUpload'
import VDatepicker from '@/components/base/VDatepicker'
import VCheckbox from '@/components/base/VCheckbox'
import VRichText from '@/components/base/VRichText'

export default {
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    isRow: {
      type: Boolean,
      default: true
    },
    isColumn: {
      type: Boolean,
      default: false
    },
    hasAddButton: {
      type: Boolean,
      default: true
    },
    hasDeleteButton: {
      type: Boolean,
      default: true
    },
    hasVisibilityToggle: {
      type: Boolean,
      default: false
    },
    value: {
    },
    rowTemplate: {
      type: Array
    },
    sendData: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean
    }
  },
  components: { VSelect, VTextField, VFileUpload, VDatepicker, VCheckbox, VRichText },
  computed: {
    hooks() {
      return {
        ...this.$listeners
      }
    },
    placeholder() {
      let obj = {};

      this.rowTemplate.forEach(item => {
        obj[item.label] = item.default;
      });

      return obj
    },
    layoutClass() {
      return this.isColumn ? 'dynamic-list--column' : 'dynamic-list--row';
    }
  },
  methods: {
    changeValue(row, prop, newValue, component) {
      if (component == 'VFileUpload') {

        if (this.sendData) {
          // Can make this part of the function into a mixin
          const projectId = this.$route.params.projectId; //not the most robust way of getting project ID and proposal ID in a component, but it's fine for now
          const proposalId = this.$route.params.proposalId;
          const imgNameBase = `prj_${projectId}_p_${proposalId}_${row}_` //can create a function that handles this

          // Create formdata for posting to the back-end
          let formData = new FormData();
          const fileName = newValue.file.name;
          formData.append('proposal_files', newValue.file, fileName);

          this.$http.images.post(
            projectId,
            proposalId,
            formData,
            { prefix: imgNameBase }
          ).then((resp) => {
            newValue.url = resp.data.files[0];
            this.value[row][prop] = newValue;
            this.$emit('input', this.value);
            this.$emit('change', { row: row, prop: prop, value: this.value });
          }).catch(err => {
            console.log(err.message);
          })
        } else {
          this.value[row][prop] = newValue;
          this.$emit('input', this.value);
          this.$emit('change', { row: row, prop: prop, value: this.value });
        }

      } else {
        this.value[row][prop] = newValue;
        this.$emit('input', this.value);
        this.$emit('change', { row: row, prop: prop, value: this.value });
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.panel-block.dynamic-list {

  .dynamic-list--row {
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    margin-right: 0.7em;

    *:not(:last-child) {
      margin-right: 0.7em;
    }
  }

  .dynamic-list--column {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    margin-right: 0.7em;

    *:not(:last-child) {
      margin-bottom: 0.3em;
    }
  }

}

.add-button {
  margin-top: 0.5em;
}
</style>
